import apiAuthClient from '@/services/apiAuthClient';
import { defaultApplication } from '@/utilities/constants';

import errorHandler from '@/utilities/serverErrorHandler';

export const actions = {
  updateApplication ({ commit, getters, dispatch, rootGetters }, payload) {
    payload.ua_totalamountrequesting = rootGetters['childEntities/getActivityTotalCost'];
    payload.ua_forecastnumberofjobs = rootGetters['childEntities/getTotalJobs'] || payload.ua_forecastnumberofjobs;
    payload.ua_businessbanksortcode = payload?.ua_businessbanksortcode?.replace(/-/g, '') || null;

    commit('UPDATE_APPLICATION', payload);

    commit('UPDATE_ADDITIONAL_POSTCODE_FIELDS');

    const application = getters.getApplication;

    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Updating your application...' }, { root: true });
    return apiAuthClient.put('icapplication', application, rootGetters['auth/getAccessToken']).then((res) => {
      commit('UPDATE_APPLICATION', application);
      if (res.status === 200) {
        return true;
      }
    }).catch((err) => {
      return errorHandler('applicationErrors', err, 'put');
    }).finally(() => {
      dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  },
  getApplication ({ commit, dispatch, rootGetters }) {
    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Finding your application...' }, { root: true });
    return apiAuthClient.get(`icapplication/${process.env.VUE_APP_CONTRACT_ID}`, rootGetters['auth/getAccessToken']).then(res => {
      if (res.status === 200) {
        commit('UPDATE_APPLICATION', res.data);
        dispatch('settings/updateDownloadedFlag', { flagName: 'appDownloaded', flagStatus: true }, { root: true });
        return true;
      }
    }).catch((err) => {
      return errorHandler('applicationErrors', err);
    }).finally(() => {
      dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  },
  updateCurrentStep ({ commit }, payload) {
    commit('UPDATE_CURRENT_STEP', payload);
  },
  resetApp ({ commit }) {
    commit('UPDATE_APPLICATION', defaultApplication);
  }
};
